// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Pages/Collections/Collection/Collection.css
// module id = 209
// module chunks = 0